module.exports = __webpack_public_path__ + "img/inu_gallery0.42f5fd1b.jpg";